import { apiSlice } from "../apiSlice";

export const specificationApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getSpecifications: builder.query({
            query: (data) => ({
                url: 'specification',
                method: 'GET',
                credentials: "include",
            }),
            providesTags: ['specification']

        }),
        createSpecificationType: builder.mutation({
            query: (data) => ({
                method: "POST",
                body: data,
                url: 'specificationType',
                credentials: "include",
            })
        }),
        getSpecificationsType: builder.query({
            query: (id) => ({
                method: "GET",
                url: 'specificationType/',
                credentials: "include",
            })
        }),

        specificationDelete: builder.mutation({
            query: (id) => ({
                url: 'specification',
                method: "DELETE",
                body: id,
                credentials: "include",
            }),
            invalidatesTags: ['specification']

        }),

        createSpecification: builder.mutation({
            query: (data) => ({
                method: "POST",
                body: data,
                url: 'specification',
                credentials: "include",
            }),
            invalidatesTags: ['specification']
        }),
        GetSpecification: builder.query({
            query: (data) => ({
                method: "GET",
                url: 'specification/' + data,
                credentials: "include",

            }),


        }),

    }),
});

export const {
    useCreateSpecificationTypeMutation,
    useGetSpecificationsQuery,
    useGetSpecificationsTypeQuery,
    useCreateSpecificationMutation,
    useSpecificationDeleteMutation,

} = specificationApi;